module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Fan-1c4afa7d656ab61e764316c0e0783e8f.svg";